import React from 'react';
import { businessServices } from '../../data/businessServices';
import ServiceSection from '../../components/ServiceSection';
import Hero from '../../components/Hero';

const Security = () => {
  const securityService = businessServices.find(service => service.title === "Securitate");

  return (
    <>
      <Hero
        title="Securitate IT"
        subtitle="Protecție completă pentru infrastructura IT a companiei tale"
        variant="compact"
        ctaLabel="Vezi Tarife"
        ctaHref="#tarife"
        backgroundImageUrl="/img/hero-business-security.jpg"
        icon={securityService?.icon}
        iconLabel={securityService?.title}
      />

      {securityService && (
        <ServiceSection
          service={securityService}
          index={0}
          pricingFirst
          id="tarife"
          showTitleBlock={false}
        />
      )}
    </>
  );
};

export default Security;
